import { Container, Row, Col } from "react-bootstrap";
import { Parser as HtmlToReactParser } from "html-to-react";
import styles from "./detail.module.scss";
import { useEffect, useState, useCallback } from "react";
import PopularPost from "./PopularPost";
import OtherServices from "pages/our-services/OtherServices";
import { useSearchParams } from "react-router-dom";
import { useAdminClient } from "hooks/useAdminClient";

const htmlToReactParser = new HtmlToReactParser();

const TaxUpdatesDetail = () => {
  const client = useAdminClient();
  const [searchParams] = useSearchParams();
  const [article, setArticle] = useState({});
  const fetchArticleDetail = useCallback(async (nextArticelId)  => {
    const response = await client.get(`/be/api/v1/articles/${nextArticelId}/detail`);
    const {data} = response;
    setArticle(data);
  }, []);


  useEffect(() => {
    window.scrollTo(0, 0)
    const id = searchParams.get("id"); // "text"
    fetchArticleDetail(id);
  }, [searchParams])
  // replace this with dynamic article contents

  return (
    <Container className={styles.container}>
      <img className="title-img" src={`${process.env.REACT_APP_API_HOST}${article.img}`} alt="img" />
      <h2 className={["mb-3", styles.title].join(" ")}>{article.title}</h2>

      <Row className="text-muted">
        <Col>{htmlToReactParser.parse(article.text)}</Col>
        <Col lg={4} md={5}>
          <div className="ms-lg-4 ps-lg-4 mt-5 mt-lg-0">
            <PopularPost />
            <OtherServices />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default TaxUpdatesDetail;
